import { LinkItem } from '@/domain/models/LinkItem';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { LinkItemService } from '@/services/LinkItem';

export const useLinkItem = async (): Promise<LinkItem[]> => {
  const linkItemService = new LinkItemService(getClient());

  return linkItemService
    .fetch()
    .catch((error: Error) => errorHandler({ error }));
};
